import React, { useEffect, useState } from "react";
import { Grid, Typography, Box, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import TextField from "../common/TextField";
import MenuItem from "../common/MenuItem";
import Button from "../common/Button";
import instance from "../../axios";
import { notifyError, notifySuccess } from "../../Utils/CustomNotifcations";
import { useDispatch, useSelector } from "react-redux";
import { checkPrivileges, handleDownloadOrPreview } from "../../Helpers";
import VisibilityIcon from "@mui/icons-material/Visibility";


const getFileName = (file) => {
    if (!file) return "";
    if (file.name) return file.name;
    if (typeof file === "string") {
        return decodeURIComponent(file.split("/").pop());
    }
    if (file.url) {
        return decodeURIComponent(file.url.split("/").pop());
    }
    return "";
};
const TICKET_TYPE_DEPARTMENTS = {
  support: "Technical Support",
  training: "Technical Support",
  "new change request": "Development",
  "bug fix": "Development",
  "general inquiry": "Operations",
  others: "Operations",
  "general request": "Operations",
  "payment billing": "Billing",
};
const CreateTicketForm = ({ translate, handleAddCloseForm, selectedTask, getTaskCounts }) => {
    const dispatch = useDispatch()
    const loginUser = useSelector((state) => state.ServerSetting)
    const userInfo = useSelector((state) => state.logInUsers)
    const [loader, setLoader] = useState(false)
    const [form, setForm] = useState({
        name: "",
        assign: "",
        description: "",
        currentStatus: "",
        date: "",
        ticketType: "",
        department: "",
        priority: "",
        labels: ["", "", "", ""],
        file: null
    });

    useEffect(() => {
        if (selectedTask) {
            setForm({
                name: selectedTask.name || "",
                assign: selectedTask.assignTo || "",
                description: selectedTask.description || "",
                currentStatus: selectedTask.currentStatus || "",
                date: selectedTask.dueDate || "",
                ticketType: selectedTask.ticketType || "",
                department: selectedTask.department || "",
                priority: selectedTask?.priority || "",
                labels: ["", "", "", ""],
                file: selectedTask?.file || null
            });
        }
    }, [selectedTask]);


  const handleChange = (field, value) => {
    setForm((prev) => ({
      ...prev,
      [field]: value,
      ...(field === "ticketType" && TICKET_TYPE_DEPARTMENTS[value]
        ? { department: TICKET_TYPE_DEPARTMENTS[value] }
        : {}),
    }));
  };


    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        if (!selectedFile) return;
        if (selectedFile.size > 5 * 1024 * 1024) {
            alert("File size must be less than 5MB");
            return;
        }
        const reader = new FileReader();
        reader.onload = (event) => {
            const base64 = event.target.result.split("base64,")[1];

            const obj = {
                name: selectedFile.name,
                contentType: selectedFile.type,
                oldUrl: "",
                entity: "ticket",
                entityId: selectedTask?.id,
                data: base64,
            };
            setForm((prevstate) => ({
                ...prevstate,
                file: obj
            }))
        };
        reader.readAsDataURL(selectedFile);
    };


    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            setLoader(true);
            let fileUrl = "";
            if (form?.file && !form.file.url && form.file.data) {
                const uploadRes = await instance.post("/api/uploads", form.file, {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                    },
                });
                fileUrl = uploadRes.url;
            } else {
                fileUrl = form?.file || ""
            }
            const payload = {
                ...(selectedTask?.id && { id: selectedTask.id }),
                ...(form.priority && { priority: form.priority }),
                name: form.name,
                contractNumber: loginUser?.contractNumber || "",
                department: form.department,
                ticketType: form.ticketType,
                description: form.description,
                file: fileUrl || "",
                currentStatus: form.currentStatus || "New",
                created: new Date(),
    attributes: {
    ...(form.attributes || {}),

    parentUser: {
      ...(form.attributes?.parentUser || {}),

      name: loginUser?.name || "",
      contractNumber: loginUser?.contractNumber || "",
      id: loginUser?.id || "",
      label: loginUser?.name || "",
      value: loginUser?.id || "",
    },
  },
            };

            if (selectedTask?.id) {
                await instance.put(`/api/tickets/${selectedTask.id}`, payload);
            } else {
                await instance.post(`/api/tickets`, payload);
            }

            handleAddCloseForm();
            getTaskCounts()
            const msg=selectedTask?"ticketUpdated":"ticketAdded"
            dispatch(notifySuccess(msg));

        } catch (err) {
            dispatch(notifyError(err?.message||"Not Updated"));
            console.error(err);
        } finally {
            setLoader(false);
        }
    };

const hasPermission = selectedTask
  ? checkPrivileges("ticketUpdate")
  : checkPrivileges("ticketCreate");
    return (
        <form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <TextField
                                label={translate("ticketSubject")}
                                variant="outlined"
                                fullWidth
                                value={form.name}
                                required
                                onChange={(e) => handleChange("name", e.target.value)}
                            />
                        </Grid>
                        {selectedTask &&
                            <>
                                <Grid item xs={6}>
                                    <TextField
                                        select
                                        label={translate("status")}
                                        variant="outlined"
                                        fullWidth
                                        value={form.currentStatus}
                                        disabled={!(userInfo?.userType === -1 || userInfo?.userType > 3)}
                                        onChange={(e) => handleChange("currentStatus", e.target.value)}
                                    >
                                        <MenuItem value="New">New</MenuItem>
                                        <MenuItem value="Assigned">Assigned</MenuItem>
                                        <MenuItem value="In Progress">In Progress</MenuItem>
                                        <MenuItem value="Awaiting Customer Response">Awaiting Customer Response</MenuItem>
                                        <MenuItem value="Resolved">Resolved</MenuItem>
                                        <MenuItem value="Closed">Closed</MenuItem>
                                    </TextField>
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField
                                        select
                                        label={translate("priorityLevel")}
                                        variant="outlined"
                                        fullWidth
                                        value={form.priority}
                                       disabled={!(userInfo?.userType === -1 || userInfo?.userType > 3)}
                                        onChange={(e) => handleChange("priority", e.target.value)}
                                    >
                                        <MenuItem value="Low">Low</MenuItem>
                                        <MenuItem value="Medium">Medium</MenuItem>
                                        <MenuItem value="High">High</MenuItem>
                                        <MenuItem value="Critical">Critical</MenuItem>
                                    </TextField>
                                </Grid>
                            </>
                        }
                        <Grid item xs={6}>
                            <TextField
                                select
                                label={translate("ticketType")}
                                variant="outlined"
                                fullWidth
                                required
                                value={form.ticketType}
                                onChange={(e) => handleChange("ticketType", e.target.value)}
                            >
                                <MenuItem value="support">Support</MenuItem>
                                <MenuItem value="training">Training</MenuItem>
                                <MenuItem value="new change request">New Change Request</MenuItem>
                                <MenuItem value="bug fix">Bug Fix</MenuItem>
                                <MenuItem value="general inquiry">General Inquiry</MenuItem>
                                <MenuItem value="payment billing">Payment Billing</MenuItem>
                                <MenuItem value="general request">General Request</MenuItem>
                                <MenuItem value="others">Others</MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                select
                                label={translate("department")}
                                variant="outlined"
                                fullWidth
                                required
                                value={form.department}
                                onChange={(e) => handleChange("department", e.target.value)}
                            >
                                <MenuItem value="Technical Support">Technical Support</MenuItem>
                                <MenuItem value="Operations">Operations</MenuItem>
                                <MenuItem value="Billing">Billing</MenuItem>
                                <MenuItem value="Development">Development</MenuItem>
                            </TextField>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextField
                        label={translate("description")}
                        variant="outlined"
                        fullWidth
                        multiline
                        required
                        rows={3.5}
                        value={form.description}
                        onChange={(e) => handleChange("description", e.target.value)}
                    />
                </Grid>
                <Grid item xs={12} md={12}></Grid>
                {selectedTask &&
                    <Grid item xs={12}>
                        <Typography mb={1}>{translate("addFile")}</Typography>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                            <Button variant="outlined" component="label" size="small" disabled={!!form?.file} sx={{
                                cursor: form?.file ? "not-allowed" : "pointer",
                                opacity: form?.file ? 0.6 : 1
                            }}>
                                {form?.file ? getFileName(form.file) : translate("chooseFile")}
                                <input
                                    type="file"
                                    hidden
                                    disabled={form?.file}
                                    onChange={handleFileChange}
                                />
                            </Button>
                            {selectedTask?.file && !form.file?.name && <IconButton
                                size="small"
                                color="primary"
                                onClick={() => handleDownloadOrPreview(selectedTask.file)}
                            >
                                <VisibilityIcon fontSize="small" />
                            </IconButton>}
                            {form?.file && (
                                <>
                                    <IconButton
                                        size="small"
                                        color="error"
                                        onClick={() =>
                                            setForm((prev) => ({
                                                ...prev,
                                                file: null
                                            }))
                                        }
                                    >
                                        <CloseIcon fontSize="small" />
                                    </IconButton>
                                </>
                            )}
                        </Box>
                    </Grid>}
                {hasPermission && (
                    <Grid item xs={12}>
                        <Box mt={2}>
                            <Button
                                type="submit"
                                variant="contained"
                                color="success"
                                disabled={
                                    !form.name || !form.ticketType || !form.department || !form.description
                                }
                            >
                                {selectedTask ? translate("update") : translate("submit")}
                            </Button>
                        </Box>
                    </Grid>
                )}
            </Grid>
        </form>

    );
};

export default CreateTicketForm;
